<script setup lang="ts">
import ApplicationLogo from '@/Components/ApplicationLogo.vue';
import DropdownLink from '@/Components/DropdownLink.vue';
import NavLink from '@/Components/NavLink.vue';
import { Link } from '@inertiajs/vue3';
</script>

<template>
    <div class="bg-light min-vh-100 d-flex flex-column">
        <nav class="navbar navbar-expand-md bg-white border-bottom">
            <div class="container">
                <Link :href="route('dashboard')" class="navbar-brand d-flex align-items-center gap-2">
                    <ApplicationLogo style="height: 28px; width: auto;" />
                </Link>

                <button
                    class="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#mainNavbar"
                    aria-controls="mainNavbar"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="mainNavbar">
                    <ul class="navbar-nav me-auto mb-2 mb-md-0">
                        <li class="nav-item">
                            <NavLink :href="route('dashboard')" :active="route().current('dashboard')">
                                Dashboard
                            </NavLink>
                        </li>
                    </ul>

                    <ul class="navbar-nav ms-auto mb-2 mb-md-0">
                        <li class="nav-item dropdown">
                            <a
                                class="nav-link dropdown-toggle"
                                href="#"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                {{ $page.props.auth.user.name }}
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end">
                                <li>
                                    <DropdownLink :href="route('profile.edit')">Profile</DropdownLink>
                                </li>
                                <li><hr class="dropdown-divider" /></li>
                                <li>
                                    <DropdownLink :href="route('logout')" method="post" as="button">Log Out</DropdownLink>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>

        <header v-if="$slots.header" class="bg-white border-bottom">
            <div class="container py-4">
                <slot name="header" />
            </div>
        </header>

        <main class="flex-fill">
            <div class="container py-4">
                <slot />
            </div>
        </main>
    </div>
</template>
